import React from "react";

const Spinner = () => {
    return (
        <div className='spinner_container'>
            <div className='spinner'></div>;
        </div>
    );
};

export default Spinner;
